import type { Task } from '@cartwheel/api/v1'
import { Button } from '@cartwheel/components'
import { trackInteraction } from '../../tracking'

const PRIMARY_ACTION_LINK_CLASSES =
  'inline-flex h-10 items-center justify-center gap-2 whitespace-nowrap rounded-lg border-[3px] border-forest bg-forest px-4 py-2 font-sans text-base font-medium leading-none text-white no-underline hover:border-forest-light hover:bg-forest-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forest focus-visible:ring-offset-2'

export function TaskDescription({ task }: { task: Task }) {
  return (
    <section>
      <h3 className="text-base font-semibold text-charcoal">Description</h3>
      <p className="mt-1 text-sm leading-[1.5] text-charcoal-50">{task.description}</p>
    </section>
  )
}

export function CanceledNotice() {
  return (
    <section className="space-y-3">
      <h3 className="text-base font-semibold leading-[1.5] text-charcoal">Task Canceled</h3>
      <div className="rounded-lg border border-sand bg-white p-4 shadow-sm">
        <p className="text-sm leading-[1.5] text-charcoal-50">
          This task was canceled and did not require completion.
        </p>
      </div>
    </section>
  )
}

export function SectionDivider() {
  return <hr className="border-gray-stroke" />
}

export function AvailabilityNote({ note }: { note: string }) {
  return (
    <div className="rounded-lg border border-sand bg-white p-4 shadow-sm">
      <p className="text-sm font-semibold leading-[1.5] text-charcoal">Note from client</p>
      <p className="mt-1 whitespace-pre-line text-sm leading-[1.5] text-charcoal-50">{note}</p>
    </div>
  )
}

export function ScheduleAppointmentsSection({
  task,
  matchingCliniciansCount,
  caseAssignmentUrl,
}: {
  task: Task
  matchingCliniciansCount?: number | null
  caseAssignmentUrl?: string | null
}) {
  return (
    <div className="rounded-lg border border-sand bg-white p-4 shadow-sm space-y-4">
      {matchingCliniciansCount != null && (
        <div>
          <p className="text-base font-semibold leading-[1.5] text-charcoal">
            {matchingCliniciansCount} matching clinicians
          </p>
          <p className="text-sm leading-[1.5] text-charcoal-50">
            With availability within the next 6 weeks
          </p>
        </div>
      )}
      {caseAssignmentUrl ? (
        <a
          href={caseAssignmentUrl}
          target="_blank"
          rel="noreferrer"
          className={PRIMARY_ACTION_LINK_CLASSES}
          onClick={(event) =>
            trackInteraction(
              {
                name: 'TASK_RESOURCE_LINK_CLICKED',
                properties: {
                  taskId: task.id,
                  taskType: task.type,
                  destination: 'case_assignment',
                },
              },
              event
            )
          }
        >
          Find a Clinician <i className="fa-solid fa-chevron-right" aria-hidden="true" />
        </a>
      ) : (
        <Button disabled>
          Find a Clinician <i className="fa-solid fa-chevron-right" aria-hidden="true" />
        </Button>
      )}
    </div>
  )
}

export function GenericWorkspace({ task }: { task: Task }) {
  return (
    <div className="space-y-8">
      <TaskDescription task={task} />
    </div>
  )
}
